import React, { FC } from 'react';

import { OfferListItem } from 'components/offer-list-item/offer-list-item';
import Picture from 'components/picture';
import { t } from 'state/intl/translations';
import { isWalmartOffer } from 'state/loyalty/hooks/utils/walmart';
import { OffersServiceMode } from 'state/loyalty/offers/types';
import { AppOffer, LoyaltyOffer, appOfferToLoyaltyOffer } from 'state/loyalty/types';

import { IncentiveCardDescription } from '../../loyalty-incentives-components/incentive-card/incentive-card.styled';
import { parseIncentiveData } from '../../loyalty-incentives-components/incentive-card/parse-incentive-data';

interface IOffersInCartProps {
  offers: AppOffer[];
  handlePress(incentive: LoyaltyOffer): void;
  handleRemove: (incentive: LoyaltyOffer) => void;
}

export const OffersInCart: FC<React.PropsWithChildren<IOffersInCartProps>> = ({
  offers,
  handlePress,
  handleRemove,
}) => {
  // A future ticket will change Remove handler to work at the item level.
  // For now this feature is used only with one offer in cart rule, so taking the first one is valid.
  const [firstOffer] = offers;
  const firstLegacyOffer = firstOffer && appOfferToLoyaltyOffer(firstOffer);

  return (
    <>
      {offers.map((offer, idx) => {
        const loyaltyOffer = appOfferToLoyaltyOffer(offer);
        const incentiveData = parseIncentiveData(loyaltyOffer);
        const {
          description,
          image,
          imageDescription,
          name: incentiveName,
          offerServiceMode,
          endDate,
          expirationDate,
          offerKind,
        } = incentiveData;

        return (
          <OfferListItem
            id={offer.cmsId}
            key={offer.loyaltyEngineId || idx}
            image={<Picture image={image} alt={imageDescription} height="97px" width="97px" />}
            header={incentiveName}
            description={description && <IncentiveCardDescription content={description} />}
            onPress={() => handlePress(loyaltyOffer)}
            offerApplied
            offerText={t('offerApplied')}
            handleRemove={() => handleRemove(firstLegacyOffer)}
            removeOfferText={t('remove')}
            serviceModeStyle={
              offerServiceMode === OffersServiceMode.DELIVERY_ONLY
                ? 'default-outline'
                : 'default-solid'
            }
            isWalmartOffer={isWalmartOffer(offer)}
            endDate={endDate}
            expirationDate={expirationDate ?? undefined}
            // Applied offers render through this component rather than the main
            // list, so the kind has to travel here too or an applied card is
            // indistinguishable by kind.
            offerKind={offerKind}
          />
        );
      })}
    </>
  );
};
